import Login from "./login";
import Search from "./search";
import React, { useState, useRef, useEffect } from "react";
function Main(props) {
  const [showSpinner, setShowSpinner] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [showSearch, setShowSearch] = useState(false);


  const searchedText = useRef();
  return (
    <main>
      {!showSearch && !props.login ? (
        <Login
          showSearch={showSearch}
          showSpinner={showSpinner}
          setToken={props.setToken}
          setLogin={props.setLogin}
          setExpire={props.setExpire}
          setShowSearch={setShowSearch}
          disableButton={disableButton}
          setShowSpinner={setShowSpinner}
          setLastLogin={props.setLastLogin}
          setDisableButton={setDisableButton}
        ></Login>
      ) : (
        <Search
          token={props.token}
          search={props.search}
          showSpinner={showSpinner}
          setSearch={props.setSearch}
          searchedText={searchedText}
          setUserId={props.setUserId}
          searchData={props.searchData}
          searchTerm={props.searchTerm}
          setShowSpinner={setShowSpinner}
          searchPages={props.searchPages}
          searchFilter={props.searchFilter}
          setSearchTerm={props.setSearchTerm}
          setSearchData={props.setSearchData}
          setSearchPages={props.setSearchPages}
          setSearchFilter={props.setSearchFilter}
          selectedPageIndex={props.selectedPageIndex}
          setSelectedPageIndex={props.setSelectedPageIndex}
        ></Search>
      )}
    </main>
  );
}
export default Main;
